import _ from 'lodash';


    var basicHtmlTagTemplate = '<{{tagName}} {{tagAttributesAsString}}>{{tagContent}}</{{tagName}}>';
    var compiledBasicHtmlTagTemplate = getHandlebarInterpolator(basicHtmlTagTemplate);
    var compiledHelperTemplate = getHandlebarInterpolator('{{key}}="{{value}}"');

    // MAIN FUNCTION
    /**
     * Method to create a html tag based string template with custom attributes (see example).
     *
     * Example.
     *   Executing the following code:
     *     var message = "John & Paul Band!";
     *     var attributesObj = { "class": "col-md-6 col-sm-12", title: message };
     *     var spanAsString = getHtmlTagWithContentAndAttrs("span", message, attributesObj);
     *     console.log(spanAsString);
     *   logs:
     *     // '<span class="col-md-6 col-sm-12" title="John & Paul Band!">John & Paul Band!</span>'
     *
     *   Notes:
     *     - "class" is a reserved word in some javascript versions so its string representation **must always** be used instead.
     *     - calling: 'getHtmlTagWithContentAndAttrs("span", message, attributesObj);' has an implicit false value for 'isContentAHtmlEl'.
     *         Use an explicit 'true' value here if you are composing html elements (so they are not processed in any manner):
     *           var spanEl = getHtmlTagWithContentAndAttrs("span", "Joey's bike", spanAttributesObj);
     *           var divEl = getHtmlTagWithContentAndAttrs("div", spanEl, divAttributesObj, true);
     *           console.log(divEl);
     *           // '<div class="col-md-6 col-sm-12"><span title="Joey's bike">Joey's bike</span></div>'
     *
     * @param tagName [mandatory] - valid html tagName
     * @param content [optional (default: "")] - content to be rendered
     * @param attributesObj [optional (default: {})] - an object where keys are attributes and values are, well, corresponding key's values
     * @param isContentAHtmlEl [optional (default: false)] - indicates whether 'content' is a HTML element or needs to be processed
     * @returns {string}
     */
    function getHtmlTagWithContentAndAttrs(tagName, content, attributesObj, isContentAHtmlEl) {
        //  TODO: handle case where the closing tag is unnecessary!  (e.g.: <img >)
        var compiledTemplate = compiledBasicHtmlTagTemplate;
        var obj = _.extend({ 'data-attrs-created': 'auto' }, _.isNil(attributesObj) ? {} : attributesObj);
        var tagAttributesAsString = getStringRepresentationFromObject(obj);
        var tagContent = content || '';

        if (_.isNil(isContentAHtmlEl) || isContentAHtmlEl === false) {
            tagContent = replaceDoubleForSingleQuotes(tagContent);
        }

        return compiledTemplate({
            tagAttributesAsString: tagAttributesAsString,
            tagContent: tagContent,
            tagName: tagName
        });
    }

    // DERIVED FUNCTIONS
    /**
     * Returns a string template wrapped by a 'div' tag with custom content and attributes
     *
     * Example.
     *   TODO!
     *
     * @param content [mandatory] - the content to be rendered
     * @param attributesObj [optional (default: {})] - an object which keys are attributes and values are their corresponding values
     * @param isMostInnerEl [optional (default: false)] - indicates whether this is the most inner HTML element and needs to be processed
     * @returns {string}
     */
    function getDivWithContentAndAttrs(content, attributesObj, isMostInnerEl) {
        if(_.isNil(isMostInnerEl)) {
            isMostInnerEl = false;
        }
        return getHtmlTagWithContentAndAttrs('div', content, attributesObj, !isMostInnerEl);
    }

    function getSpanWithContentAndAttrs(content, attributesObj) {
        return getHtmlTagWithContentAndAttrs('span', content, attributesObj);
    }

    // HELPER FUNCTIONS
    function getHandlebarInterpolator(text) {
        return _.template(text, { interpolate: /{{([\s\S]+?)}}/g });
    }

    function getStringRepresentationFromObject(obj) {
        return _
            .keys(obj)
            .map(function (key) {
                return compiledHelperTemplate({ key: key, value: replaceDoubleForSingleQuotes(obj[key]) });
            })
            .join(' ');
    }

    function replaceAll(originalString, symbolAndReplacementArrays) {
        var result = originalString;

        if (_.isString(originalString) && !_.isEmpty(originalString)) {
            if (_.isArray(_.first(symbolAndReplacementArrays))) {
                _.forEach(symbolAndReplacementArrays, function (currentSymbolAndReplacementArray) {
                    result = replaceAllBase(result, currentSymbolAndReplacementArray);
                });
            }
            else {
                result = replaceAllBase(result, symbolAndReplacementArrays);
            }
        }
        return result;
    }

    function replaceAllBase(originalString, symbolAndReplacementArray) {
        var result = originalString;


        if (_.isString(originalString) && !_.isEmpty(originalString)) {
            if (_.isEmpty(symbolAndReplacementArray) || !_.isArray(symbolAndReplacementArray)) {
                symbolAndReplacementArray = [null, ''];
            }

            while (result.indexOf(symbolAndReplacementArray[0]) >= 0) {
                result = result.replace(symbolAndReplacementArray[0], symbolAndReplacementArray[1]);
            }
        }
        return result;
    }

    function replaceDoubleForSingleQuotes(text) {
        return replaceAll(text, ['"', "'"]);
    }

    // "EXPORTED" COMPOSED OBJECT
    export default {
        getDivWithContentAndAttrs: getDivWithContentAndAttrs,
        getHandlebarInterpolator: getHandlebarInterpolator,
        getHtmlTagWithContentAndAttrs: getHtmlTagWithContentAndAttrs,
        getSpanWithContentAndAttrs: getSpanWithContentAndAttrs
    };
